<template>
	<v-simple-table class="custom-simple-table">
		<template v-slot:default>
			<tbody>
				<tr
					v-for="(header, indexHeader) in computedHeaders"
					:key="`row-${indexHeader}`"
				>
					<td
						:class="computedBackground"
						class="text-center font-weight-medium"
						style="width: 20%"
					>
						{{ header.text }}
					</td>
					<td class="text-center py-1">
						<template v-if="header.value == 'tipo'">
							{{ computedNombreTipo }}
						</template>
						<template v-else-if="header.value == 'mantenimiento'">
							{{ computedNombreMantenimiento }}
						</template>
						<template v-else-if="header.value == 'responsables'">
							<template
								v-for="(
									responsable, indexResponsable
								) in actividad[header.value]"
							>
								<p
									class="mb-0"
									:key="`responsable-${indexResponsable}`"
								>
									{{
										actividad[header.value].length > 1
											? "•"
											: ""
									}}
									{{ responsable.nombre }}
								</p>
							</template>
						</template>
						<template
							v-else-if="header.value == 'inicioCronometro'"
						>
							<Cronometro
								:milisegundos="enCurso ? inicioCronometro : actividad[header.value]"
								:utc="actividad.tiempoPeriodosMs == 0"
							/>
						</template>
						<template v-else>
							{{ actividad[header.value] }}
						</template>
					</td>
				</tr>
			</tbody>
		</template>
	</v-simple-table>
</template>

<script>
import { mapState } from 'vuex';
import Cronometro from "./Cronometro.vue";

export default {
	components: { Cronometro },
	props: {
		actividad: {
			type: Object,
			required: true,
		},
		enCurso: {
			type: Boolean,
			default: false
		},
		inicioCronometro: {
			type: Number,
			default: 0
		}
	},
	data(){
		return {
			actividadesHeaders: [
				{
					text: "Tipo",
					align: "center",
					value: "tipo",
				},
				{
					text: "Responsables",
					align: "center",
					value: "responsables",
				},
				{
					text: "Mantenimiento",
					align: "center",
					value: "mantenimiento",
				},
				{
					text: "Categoría de Máquina",
					align: "center",
					value: "maquinaCategoria",
				},
				{
					text: "Máquina",
					align: "center",
					value: "maquinaIns",
				},
				{
					text: "Fecha Programada",
					align: "center",
					value: "inicio",
				}
			],
		}
	},
	computed: {
		...mapState(["tiposMantenimiento"]),
		computedHeaders() {
			return this.enCurso
				? [
					...this.actividadesHeaders,
					{
						text: "Tiempo transcurrido",
						align: "center",
						value: "inicioCronometro",
					},
				]
				: this.actividadesHeaders;
		},
		computedNombreMantenimiento() {
			return `[${this.actividad.codigo}] - ${this.actividad.nombre}`;
		},
		computedNombreTipo() {
			const tipoMtto = this.tiposMantenimiento.find((t) => t.value == this.actividad.tipo);
			return tipoMtto?.text || "N/A";
		},
		computedBackground() {
			switch (this.actividad.tipo) {
				case 1:
					return "background-green";
				case 2:
					return "background-blue";
				case 3:
					return "background-pink";
				case 4:
					return "background-orange";
				case 5:
					return "background-indigo";
				case 6:
					return "background-deep-purple";
				default:
					return "background-grey";
			}
		},
	},
};
</script>

<style scoped>
.custom-simple-table {
	height: 100%;
}

.custom-simple-table >>> .v-data-table__wrapper {
	height: 100%;
}

.custom-simple-table >>> table {
	height: 100%;
}

.background-green {
	background-color: #a5d6a7;
}

.background-pink {
	background-color: #f48fb1;
}

.background-orange {
	background-color: #ffcc80;
}

.background-blue {
	background-color: #90caf9;
}

.background-grey {
	background-color: #e0e0e0;
}

.background-indigo {
	background-color: #9FA8DA;
}

.background-deep-purple {
	background-color: #B39DDB;
}

</style>